import type { MenuPopupProps, MenuPositionerProps } from '@base-ui/react';

import { Menu as BaseMenu } from '@base-ui/react';

import { useCollisionPadding } from '~/hooks/useCollisionPadding';
import { clsxs } from '~/styles/utils';

import { popupStyle } from './Menu.css';

type Props = MenuPopupProps & {
  align?: MenuPositionerProps['align'];
  side?: MenuPositionerProps['side'];
};

export const MenuList = ({ align = 'end', children, side = 'bottom', ...delegated }: Props) => {
  const collisionPadding = useCollisionPadding();

  return (
    <BaseMenu.Portal>
      <BaseMenu.Positioner align={align} collisionPadding={collisionPadding} side={side} sideOffset={8}>
        <BaseMenu.Popup {...delegated} className={clsxs(popupStyle, delegated.className)}>
          {children}
        </BaseMenu.Popup>
      </BaseMenu.Positioner>
    </BaseMenu.Portal>
  );
};
